const normalizeSelectionKey = (value) => {
  if (value === null || value === undefined || value === "") return null;
  return String(value);
};

const SELF_SELECTION_KEY = "__SELF__";

const selectionMapFromCachedList = (cachedList = []) => {
  const selectionMap = {};

  cachedList?.forEach((group) => {
    const groupKey = normalizeSelectionKey(group?.value);
    if (!groupKey) return;

    if (Array.isArray(group?.children) && group.children.length > 0) {
      const selectedChildren = new Set();

      group.children.forEach((child) => {
        const childKey = normalizeSelectionKey(child?.value);
        if (child?.isSelected && childKey) selectedChildren.add(childKey);
      });

      if (selectedChildren.size > 0) selectionMap[groupKey] = selectedChildren;
      return;
    }

    if (group?.isSelected) selectionMap[groupKey] = new Set([SELF_SELECTION_KEY]);
  });

  return selectionMap;
};

const applySelectionMapToFresh = (freshList = [], savedSelections = {}) =>
  freshList?.map((group) => {
    const groupKey = normalizeSelectionKey(group?.value);
    const selectedChildren = groupKey ? savedSelections[groupKey] : null;
    const nextGroup = { ...group };

    if (Array.isArray(group?.children) && group.children.length > 0) {
      nextGroup.children = group.children.map((child) => {
        const childKey = normalizeSelectionKey(child?.value);

        return {
          ...child,
          isSelected: !!(childKey && selectedChildren?.has(childKey)),
        };
      });
      nextGroup.isSelected = nextGroup.children.some((child) => child.isSelected);
      return nextGroup;
    }

    nextGroup.isSelected = !!selectedChildren?.has(SELF_SELECTION_KEY);
    return nextGroup;
  });

export { applySelectionMapToFresh, selectionMapFromCachedList };
